var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPenghasilanBesar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 104,
    height: 128.906,
    viewBox: "0 0 104 128.906",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.84,
    y1: 0.13,
    x2: 0.14,
    y2: 0.843,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0783d",
    stopOpacity: 0.482
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-692 -331)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 52,
    r: 52,
    transform: "translate(692 331)",
    opacity: 0.266,
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(705.472 102.404)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.529 280.596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.626,280.6H56.25a6.664,6.664,0,0,1,6.678,6.678v45.95A6.664,6.664,0,0,1,56.25,339.9H7.626a6.664,6.664,0,0,1-6.678-6.678v-45.95A6.664,6.664,0,0,1,7.626,280.6Z",
    transform: "translate(-0.948 -280.596)",
    fill: "#ffca3a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8,280.6v11.739A3.13,3.13,0,0,0,8.94,295.47h8.678a3.13,3.13,0,0,0,3.139-3.135V280.6Z",
    transform: "translate(17.711 -280.595)",
    fill: "#eae8e8"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.256 38.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.885,288.605a1.284,1.284,0,0,0,.123,2.564H8.654a1.282,1.282,0,0,0,0-2.564Z",
    transform: "translate(-2.611 -288.605)",
    fill: "#ff9700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.935,290.2a1.282,1.282,0,1,0,0,2.564h9.292a1.282,1.282,0,1,0,0-2.564Z",
    transform: "translate(-2.652 -282.462)",
    fill: "#ff9700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.415,8.854a2.568,2.568,0,0,0-2.37,1.555,32.32,32.32,0,0,0-1.82,17.524h5.233C9.423,19.966,12.737,12.5,12.737,12.5a2.568,2.568,0,0,0-2.322-3.648Z",
    transform: "translate(11.13 -7.325)",
    fill: "#ff9700"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M54.465,310.4A23.716,23.716,0,1,1,30.748,286.68,23.716,23.716,0,0,1,54.465,310.4Z",
    transform: "translate(22.444 -257.207)",
    fill: "#dad4d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.462,290.736a2.564,2.564,0,0,0-2.441,2.914,13.085,13.085,0,0,1-4.608,10.985A11.635,11.635,0,0,1,14.058,306.8a2.564,2.564,0,1,0-1.845,4.778s8.981,3.378,16.521-3.037a18.88,18.88,0,0,0,6.377-15.527,2.564,2.564,0,0,0-2.649-2.28Z",
    transform: "translate(35.626 -241.621)",
    fill: "#a29292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.176,302.3a13.52,13.52,0,1,1-13.52-13.52,13.52,13.52,0,0,1,13.52,13.52Z",
    transform: "translate(30.536 -249.115)",
    fill: "#ffc861"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.26,9.463a1.287,1.287,0,0,0-1.271,1.3v.2c-5.29,1.365-4.128,9.421,1.043,9.353,3.211.055,2.782,4.207.607,4.343a2.233,2.233,0,0,1-2.482-1.582,1.284,1.284,0,1,0-2.475.664,4.751,4.751,0,0,0,3.307,3.322v.158a1.284,1.284,0,1,0,2.568,0v-.165a4.731,4.731,0,0,0-1.3-9.285c-2.863-.034-2.7-3.938-.379-4.313a1.985,1.985,0,0,1,2.425,1.482,1.3,1.3,0,1,0,2.53-.562A4.617,4.617,0,0,0,16.556,11v-.238A1.283,1.283,0,0,0,15.26,9.463Z",
    transform: "translate(37.977 33.819)",
    fill: "#666"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenghasilanBesar);
export default __webpack_public_path__ + "static/media/penghasilan-besar.e28e75b6920a9b050f3de3fd072ed53c.svg";
export { ForwardRef as ReactComponent };